import { FC } from "react";
import { SPACE_GENDERS, SPACE_TYPES } from "../../enums/Space";
import {
  BarbellIcon,
  BasketballIcon,
  FootballIcon,
  GenderFemaleIcon,
  GenderIntersexIcon,
  GenderMaleIcon,
  IconProps,
  PersonSimpleRunIcon,
  RacquetIcon,
  SoccerBallIcon,
  VolleyballIcon,
} from "@phosphor-icons/react";

export const GenderIcon: FC<
  {
    type?: SPACE_GENDERS;
  } & IconProps
> = ({ type, ...otherProps }) => {
  if (!type || typeof type !== "string") return null;
  const Icon = {
    [SPACE_GENDERS.MALE]: GenderMaleIcon,
    [SPACE_GENDERS.FEMALE]: GenderFemaleIcon,
    [SPACE_GENDERS.MIXED]: GenderIntersexIcon,
  }?.[type];

  return <Icon {...otherProps} />;
};
export const TypeSpaceIcon: FC<
  {
    type?: SPACE_TYPES;
  } & IconProps
> = ({ type, ...otherProps }) => {
  if (!type || typeof type !== "string") return null;
  const Icon = {
    [SPACE_TYPES.SOCCER]: SoccerBallIcon,
    [SPACE_TYPES.BASKET]: BasketballIcon,
    [SPACE_TYPES.ATHLETICS]: PersonSimpleRunIcon,
    [SPACE_TYPES.VOLLER_BALL]: VolleyballIcon,
    [SPACE_TYPES.RUGBY_UNION]: FootballIcon,
    [SPACE_TYPES.GYM]: BarbellIcon,
  }[type];
  return <Icon {...otherProps} />;
};
